// Definición de defaults

export const defaultTipoNoCelebracion: TipoNoCelebracionProps = {
    idTipoNoCelebracion:    0,
    descripcion:            '',
    activo:                 false
};

// Creación de interfaces

export interface TipoNoCelebracionProps   {
    idTipoNoCelebracion:    number;
    descripcion:            string;
    activo:                 boolean;
}